export const CHILD_COPY_SECTIONS = [
  {
    id: "address",
    labelKey: "_copy_section_address",
    fields: ["address_line_1", "apt", "city", "state", "zip", "phone", "parent_language"],
  },
  {
    id: "mother",
    labelKey: "_section_mothers_info",
    fields: ["mother_name", "mother_phone", "mother_email", "mother_catholic"],
  },
  {
    id: "father",
    labelKey: "_section_fathers_info",
    fields: ["father_name", "father_phone", "father_email", "father_catholic"],
  },
  {
    id: "guardian",
    labelKey: "_section_guardian",
    fields: [
      "guardian_name",
      "guardian_phone",
      "guardian_email",
      "guardian_catholic",
      "parents_separated",
      "other_parent_legal_access",
      "has_court_order",
      "court_order_details",
    ],
  },
  {
    id: "emergency",
    labelKey: "_section_emergency_contacts",
    fields: [
      "emergency1_name",
      "emergency1_relation",
      "emergency1_phone",
      "emergency2_name",
      "emergency2_relation",
      "emergency2_phone",
      "emergency_auth",
      "emergency_signature",
    ],
  },
  {
    id: "photo",
    labelKey: "_section_photo_consent",
    fields: ["photo_consent", "photo_signature"],
  },
  {
    id: "signature",
    labelKey: "_section_signature",
    fields: ["signature"],
  },
];

export const BAPTISM_COPY_SECTIONS = [
  {
    id: "mother",
    labelKey: "_section_mothers_info",
    fields: ["mother_name", "mother_phone", "mother_email"],
  },
  {
    id: "father",
    labelKey: "_section_fathers_info",
    fields: ["father_name", "father_phone", "father_email"],
  },
  {
    id: "address",
    labelKey: "_section_home_address",
    fields: ["address_line_1", "city", "state", "zip_code"],
  },
  {
    id: "godfather",
    labelKey: "_section_godfather",
    fields: ["godfather_name", "godfather_religion", "godfather_phone", "godfather_email"],
  },
  {
    id: "godmother",
    labelKey: "_section_godmother",
    fields: ["godmother_name", "godmother_religion", "godmother_phone", "godmother_email"],
  },
];

export const ADULT_COPY_SECTIONS = [
  {
    id: "address",
    labelKey: "_copy_section_address",
    fields: ["address_line_1", "apt", "city", "state", "zip", "phone", "cell", "email"],
  },
  {
    id: "family",
    labelKey: "_section_family_data",
    fields: ["father_name", "father_religion", "mother_name", "mother_religion"],
  },
  {
    id: "emergency",
    labelKey: "_section_emergency_contacts",
    fields: [
      "emergency1_name",
      "emergency1_relation",
      "emergency1_phone",
      "emergency1_email",
      "emergency2_name",
      "emergency2_relation",
      "emergency2_phone",
      "emergency2_email",
      "emergency3_name",
      "emergency3_relation",
      "emergency3_phone",
      "emergency3_email",
      "emergency3_cell",
      "emergency_auth",
      "emergency_signature",
    ],
  },
  {
    id: "photo",
    labelKey: "_section_photo_consent",
    fields: ["photo_consent", "photo_consent_name", "photo_signature"],
  },
  {
    id: "signature",
    labelKey: "_section_signature",
    fields: ["signature"],
  },
];

export function pickFieldsFromData(sourceData, sections, selectedSectionIds) {
  if (!sourceData || !selectedSectionIds?.length) return {};
  const selected = new Set(selectedSectionIds);
  const patch = {};
  sections.forEach((section) => {
    if (!selected.has(section.id)) return;
    section.fields.forEach((field) => {
      if (Object.prototype.hasOwnProperty.call(sourceData, field)) {
        patch[field] = sourceData[field];
      }
    });
  });
  return patch;
}

export function applyCopyPatch(setValue, patch) {
  Object.entries(patch).forEach(([field, value]) => {
    setValue(field, value, { shouldDirty: true, shouldTouch: false, shouldValidate: true });
  });
}
